import type { createRoot } from 'react-dom/client';

declare global {
    interface Window {
        React: typeof import('react');
        ReactDOM: typeof import('react-dom') & {
            client: {
                createRoot: typeof createRoot;
            };
        };
        Zephr?: {
            accessDetails?: {
                activeProducts?: string[];
                isAuthenticated?: boolean;
            };
        };
        awGetUserData?: () => Record<string, unknown> | null;
        awGetUserType?: () => string;
        zephr_object?: {
            ajaxurl: string;
            pluginUrl: string;
            countryList?: Record<string, string>;
            limitedProductList?: string[];
        };
        Cookies?: {
            get: (name: string) => string | undefined;
            set: (name: string, value: string, attributes?: { expires?: number | Date; path?: string; sameSite?: string; secure?: boolean }) => void;
            remove: (name: string, attributes?: { path?: string }) => void;
        };
    }
}

export {};
